function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.123 11.144L8.749 5.519V2.406h.438a.437.437 0 100-.875H4.812a.437.437 0 100 .875h.437V5.52l-3.374 5.625a.875.875 0 00.75 1.325h8.75a.877.877 0 00.75-1.325h-.002zM7.197 8.797c-.87-.44-1.698-.674-2.473-.7l1.338-2.232a.434.434 0 00.062-.225V2.406h1.75V5.64c0 .08.022.157.063.225l2.09 3.487c-.654.128-1.59.073-2.83-.555z",
  fill: "currentColor"
});

var SvgLabFlask2 = function SvgLabFlask2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgLabFlask2;